/**
 * Polyfills for Office Add-in taskpane context
 *
 * The history API may be null/restricted in Office iframe environment.
 * This module provides no-op polyfills to prevent errors.
 */
/**
 * Ensure Ctrl+C / Cmd+C works inside the Office taskpane WebView.
 *
 * On Windows the taskpane WebView often blocks the Clipboard API
 * (`navigator.clipboard`) and may swallow the default copy behaviour.
 * By listening for the `copy` event we can explicitly write the current
 * text selection into the clipboard via `ClipboardEvent.clipboardData`,
 * which is supported even in older Edge/IE WebViews.
 */
function initClipboardPolyfill() {
    document.addEventListener('copy', (e) => {
        const selection = window.getSelection();
        if (!selection || selection.isCollapsed)
            return;
        const text = selection.toString();
        if (!text)
            return;
        // If the event already has clipboardData we can write to it directly.
        // This path works even when navigator.clipboard is blocked.
        if (e.clipboardData) {
            e.clipboardData.setData('text/plain', text);
            e.preventDefault();
        }
    });
}
export function initPolyfills() {
    // Note: In Office taskpane, replaceState/pushState are explicitly null (not undefined)
    console.log('[Polyfill] Checking history API - replaceState:', window.history?.replaceState, 'pushState:', window.history?.pushState);
    if (window.history &&
        (window.history.replaceState === null || typeof window.history.replaceState !== 'function')) {
        console.log('[Polyfill] Adding no-op window.history.replaceState for Office taskpane context');
        window.history.replaceState = function () { };
    }
    if (window.history &&
        (window.history.pushState === null || typeof window.history.pushState !== 'function')) {
        console.log('[Polyfill] Adding no-op window.history.pushState for Office taskpane context');
        window.history.pushState = function () { };
    }
    console.log('[Polyfill] After polyfill - replaceState:', typeof window.history?.replaceState, 'pushState:', typeof window.history?.pushState);
    // Ensure copy (Ctrl+C / Cmd+C) works in the Office WebView
    initClipboardPolyfill();
}
